import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";
import type { PendingAction } from "@/hooks/useCopilot";

const actionLabels: Record<string, string> = {
  resend_onboarding_email: "Resend Onboarding Email",
  create_internal_note: "Create Internal Note",
  close_support_ticket: "Close Support Ticket",
  acknowledge_incident: "Acknowledge Incident",
  resolve_incident: "Resolve Incident",
};

interface CopilotConfirmDialogProps {
  action: PendingAction | null;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function CopilotConfirmDialog({
  action,
  open,
  onConfirm,
  onCancel,
}: CopilotConfirmDialogProps) {
  if (!action) return null;

  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Confirm Action
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                You are about to execute:{" "}
                <strong>{actionLabels[action.toolName] ?? action.toolName}</strong>
              </p>
              <div className="bg-muted rounded-md p-3 text-xs space-y-1">
                {Object.entries(action.args).map(([key, val]) => (
                  <div key={key} className="flex gap-2">
                    <span className="text-muted-foreground capitalize min-w-[80px]">
                      {key.replace(/_/g, " ")}:
                    </span>
                    <span className="font-mono">{String(val)}</span>
                  </div>
                ))}
              </div>
              <p className="text-xs text-muted-foreground">
                This action will be logged in the audit trail.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Confirm & Execute
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
